<template>
  <div id="" class="container" @mousemove="touchmove" @mouseup="touchEnd">
    <div class="header">
      <el-row style="font-size: 20px" class="course_title">
          <el-col :span="23">
          <div class="course_title_name">课程考核评分标准</div>
        </el-col>
        <el-col :span="1">
          <el-button
            type="primary"
            size="small"
            class="course_save"
            @click="saveCourseScale"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="slider">
      <div class="ruler" id="ruler" ref="ruler">
        <div
          ref="passbar"
          class="bar startbar"
          @mousedown="passTouchStart"
          @mouseup="touchEnd"
          :style="'left:' + (startStep * 10 - 0.65) + '%'"
        ></div>
        <div
          ref="goodbar"
          class="bar endbar"
          @mousedown="goodTouchstart"
          @mouseup="touchEnd"
          :style="'left:' + (goodStep * 10 - 0.65) + '%'"
        ></div>
        <div
          ref="excellentbar"
          class="bar excellentbar"
          @mousedown="excellentTouchstart"
          @mouseup="touchEnd"
          :style="'left:' + (excellentStep * 10 - 0.65) + '%'"
        ></div>
        <!-- <div ref="passbar" class="bar startbar" @mousedown="passTouchStart" @mouseup="touchEnd" :style="'left:'+ (startStep * step) + 'px'"></div>
          <div ref="goodbar" class="bar endbar" @mousedown="goodTouchstart" @mouseup="touchEnd" :style="'left:'+ (goodStep * step) + 'px'"></div>
          <div ref="excellentbar" class="bar excellentbar" @mousedown="excellentTouchstart" @mouseup="touchEnd" :style="'left:'+ (excellentStep * step) + 'px'"></div> -->
        <!-- <div ref="passbar" class="bar startbar" @mousedown="passTouchStart" @mouseup="touchEnd" style="left:60%"></div>
          <div ref="goodbar" class="bar endbar" @mousedown="goodTouchstart" @mouseup="touchEnd" style="left:80%"></div>
          <div ref="excellentbar" class="bar excellentbar" @mousedown="excellentTouchstart" @mouseup="touchEnd" style="left:90%"></div> -->
      </div>
      <!-- <div class="clearfix">
          <div class="">{{startStep}}</div>
          <div class="">{{goodStep}}</div>
          <div class="">{{excellentStep}}</div>
        </div> -->
      <div class="score-progress">
        <div
          class="score-stage nopass-stage"
          :style="'width:' + startStep * 10 + '%'"
        >
          不合格
        </div>
        <div
          class="score-stage pass-stage"
          :style="'width:' + (goodStep * 10 - startStep * 10) + '%'"
        >
          合格
        </div>
        <div
          class="score-stage good-stage"
          :style="'width:' + (excellentStep * 10 - goodStep * 10) + '%'"
        >
          良好
        </div>
        <div
          class="score-stage excellent-stage"
          :style="'width:' + (100 - excellentStep * 10) + '%'"
        >
          优秀
        </div>
      </div>
      <div class="scale">
        <div class="scale-li" style="width: 0%">0</div>
        <div class="scale-li">10</div>
        <div class="scale-li">20</div>
        <div class="scale-li">30</div>
        <div class="scale-li">40</div>
        <div class="scale-li">50</div>
        <div class="scale-li">60</div>
        <div class="scale-li">70</div>
        <div class="scale-li">80</div>
        <div class="scale-li">90</div>
        <div class="scale-li">100</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/assessment/assessmentEdit.js'
export default {
  name: 'AssessmentEdit',
  data() {
    return {
      id: '',
      uid: '',
      courseId: this.$route.query.courseId || this.$route.query.id,
      $ruler: '', // 滑竿
      $bar: '', // 左侧滑块
      $endbar: '', // 右侧滑块
      startX: '', // 左侧滑块位置
      endX: '', // 右侧滑块位置
      step: '', // 滑竿在限定范围内可以分多少步
      intervalStart: 0, //最小步数
      intervalEnd: 10, //最大步数
      startStep: 6, //及格滑块所在步数
      goodStep: 8, //良好滑块所在步数
      excellentStep: 9, //优秀滑块所在步数
      amountW: '', //  滑竿多长距离
    }
  },
  // watch: {
  //   startStep(value) {
  //     console.log('及格', value)
  //     console.log('良好', this.goodStep)
  //     console.log('优秀', this.excellentStep)
  //   },
  //   goodStep(value) {
  //     console.log('及格', this.startStep)
  //     console.log('良好', value)
  //     console.log('优秀', this.excellentStep)
  //   },
  //   excellentStep(value) {
  //     console.log('及格', this.startStep)
  //     console.log('良好', value)
  //     console.log('优秀', value)
  //   },
  // },
  created() {
    const that = this
    that.$nextTick(() => {
      that.initSlider()
      this.getCourseScale()
    })
  },
  methods: {
    initSlider() {
      const that = this
      that.$ruler = that.$refs.ruler
      that.$passbar = that.$refs.passbar
      that.$goodbar = that.$refs.goodbar
      that.$excellentbar = that.$refs.excellentbar
      // 滑竿多长距离
      that.amountW = that.$ruler.clientWidth - that.$passbar.clientWidth
      // 总共多少步
      that.step = that.amountW / (that.intervalEnd - that.intervalStart)
    },
    passTouchStart(e) {
      const that = this
      // 开始滑动时滑块的位置
      that.startX = e.pageX
      that.moving = true
      that.moveOption = 'pass'
    },
    touchmove(e) {
      const that = this
      if (that.moving) {
        if (that.moveOption == 'pass') {
          that.passTouchmove(e)
        } else if (that.moveOption == 'good') {
          that.goodTouchmove(e)
        } else if (that.moveOption == 'excellent') {
          that.excellentTouchmove(e)
        }
      }
    },
    touchEnd: function () {
      this.moving = false
    },
    goodTouchstart(e) {
      const that = this
      // 开始滑动时滑块的位置
      that.endX = e.pageX
      that.moving = true
      that.moveOption = 'good'
    },
    // 及格滑块移动事件
    passTouchmove(e) {
      const that = this
      // 滑动距离=当前滑块x距离-最开始滑块距离
      let slidedis = e.pageX - that.$ruler.offsetLeft
      // 滑动距离小于0 或者大于滑竿的宽度，return掉
      if (slidedis < 0 || slidedis > that.amountW) {
        return
      }
      let ste = Math.round(slidedis / that.step)
      // 及格滑块要超过良好滑块时，return掉
      if (ste + that.intervalStart > that.goodStep) {
        return
      }
      that.startStep = ste + that.intervalStart
      // that.$passbar.style.left = (ste * that.step) + 'px'
      // console.log(ste)
    },
    // 良好滑块移动事件
    goodTouchmove(e) {
      const that = this
      // 滑动距离=当前滑块x距离-最开始滑块距离
      let slidedis = e.pageX - that.$ruler.offsetLeft

      if (slidedis < 0 || slidedis > that.amountW) {
        return
      }
      let ste = Math.round(slidedis / that.step)
      if (that.goodStep == 10) {
        that.$goodbar.style.left = ''
        that.$goodbar.style.right = '0px'
      } else if (that.startStep > ste + that.intervalStart) {
        //当良好滑块，要小于及格滑块时，return掉
        return
      } else if (ste + that.intervalStart > that.excellentStep) {
        //当良好滑块，要超过优秀滑块时，return掉
        return
      } else {
        that.goodStep = ste + that.intervalStart
        // that.$goodbar.style.left = (ste * that.step) + 'px'
      }
    },
    excellentTouchstart(e) {
      const that = this
      // 开始滑动时滑块的位置
      that.endX = e.pageX
      that.moving = true
      that.moveOption = 'excellent'
    },
    // 优秀滑块移动事件
    excellentTouchmove(e) {
      const that = this
      // 滑动距离=当前滑块x距离-最开始滑块距离
      let slidedis = e.pageX - that.$ruler.offsetLeft
      // 滑动距离小于0 或者大于滑竿的宽度，return掉
      if (slidedis < 0 || slidedis > that.amountW) {
        return
      }
      let ste = Math.round(slidedis / that.step)
      if (ste + that.intervalStart > that.intervalEnd) {
        return
      } else if (ste + that.intervalStart < that.goodStep) {
        //当优秀滑块，要小于良好滑块时，return掉
        return
      } else {
        that.excellentStep = ste + that.intervalStart
        // that.$excellentbar.style.left = (ste * that.step) + 'px'
      }
    },
    goBack() {
      window.history.go(-1)
    },
    //获取课程考核评分标准
    getCourseScale() {
      const courseId = this.courseId
      api.getCourseScale({ courseId }).then((data) => {
        if (data.data.code === 100000 && data.data.data !== null) {
          const { id, uid, passScore, middleScore, topScore } = data.data.data
          console.log(passScore, middleScore, topScore)
          this.id = id
          this.uid = uid
          this.startStep = passScore / 10
          this.goodStep = middleScore / 10
          this.excellentStep = topScore / 10
        }
      })
    },
    //保存课程考核评分标准
    saveCourseScale() {
      const { id, uid, courseId, startStep, goodStep, excellentStep } =
        this.$data
      const passScore = startStep * 10
      const middleScore = goodStep * 10
      const topScore = excellentStep * 10
      console.log(courseId)
      api
        .saveCourseScale({
          id,
          uid,
          courseId,
          passScore,
          middleScore,
          topScore,
        })
        .then((data) => {
          const { code, msg } = data.data
          if (code === 100000) {
            this.$message({
              type: 'success',
              message: msg,
            })
            this.getCourseScale()
          } else {
            this.$message.error(msg)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  border: 2px solid #eee;
  padding-bottom: 30px;
}
.course_title {
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #f7f7f7;
  padding-left: 26px;
  .course_title_name {
    color: #888;
  }
  .course_save {
    width: 66px;
  }
}
.clearfix {
  &:after {
    content: '';
    display: block;
    clear: both;
  }
}
.slider {
  margin: auto;
  width: 80%;
  .ruler {
    background: #879bae;
    // height: 1px;
    position: relative;
    margin-top: 75px;
    .bar {
      position: absolute;
      top: -12px;
      // height: 1rem;
      // width: 1rem;
      // border-radius: 100%;
      // background: #d8d8d8;
      font-size: 0.3rem;
      line-height: 0.65rem;
      text-align: center;
      cursor: pointer;
      border-top: 10px solid #d8d8d8;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      &::before {
        position: absolute;
        left: -10px;
        top: -20px;
        width: 20px;
        height: 10px;
        content: '';
        background-color: #d8d8d8;
      }
    }
    .startbar {
      left: 0;
    }
  }
  .score-progress {
    display: flex;
    justify-content: left;
    .score-stage {
      padding: 10px 0;
      font-size: 16px;
      color: white;
      white-space: nowrap;
      text-align: center;
      user-select: none;
    }
    .nopass-stage {
      background-color: #b7ddf5;
    }
    .pass-stage {
      background-color: #93cbf0;
    }
    .good-stage {
      background-color: #6fbaeb;
    }
    .excellent-stage {
      background-color: #4ba9e6;
    }
  }
  .scale {
    display: flex;
    justify-content: left;
    .scale-li {
      width: 10%;
      font-size: 16px;
      text-align: right;
      user-select: none;
    }
  }
}
</style>
